import {clsx} from 'clsx'
import type {ComponentProps} from 'react'
import {forwardRef} from 'react'

import styles from './card-base.module.css'

export const CardBase = forwardRef<HTMLDivElement, ComponentProps<'div'>>(({className, ...props}, ref) => (
  <div className={clsx(className, styles.CardBase)} {...props} ref={ref} />
))
CardBase.displayName = 'CardBase'
